import Button from '../../components/Button'
import { useState } from 'react';

const CreateEmployeeForm = ({OnCancel}) => {

    const handleSubmit = (event) => {
        // Handle form submission logic
        event.preventDefault();
        console.log('Form submitted');
      };

      const [isChecked1, setIsChecked1] = useState(false);
      const [isChecked2, setIsChecked2] = useState(false);
      const [isChecked3, setIsChecked3] = useState(false);
    
      const handleCheckboxChange1 = () => {
        setIsChecked1(!isChecked1);
      };
    
      const handleCheckboxChange2 = () => {
        setIsChecked2(!isChecked2);
      };
    
      const handleCheckboxChange3 = () => {
        setIsChecked3(!isChecked3);
      };

  return (
    <form action="" className='create-customer-form-expanded flex flex-col gap-10' onSubmit={handleSubmit}> 
        <section className='flex gap-10 employee-form-name-section'>
            <div className='flex flex-col'>
                <label htmlFor="">First name</label>
                <input type="text" placeholder='Enter first name' className='mt-2'/>
            </div>

            <div className='flex flex-col'>
                <label htmlFor="">Last name</label>
                <input type="text" placeholder='Enter last name' className='mt-2'/>
            </div>
            
        </section>

        <section className='flex gap-10 employee-form-name-section'>
            <div className='flex flex-col service-name-input'>
                <label htmlFor="">Phone number</label>
                <input type="text" placeholder='Enter phone number' className='mt-2'/>
            </div>

            <div className='flex flex-col service-name-input'>
                <label htmlFor="">Email Address</label>
                <input type="text" placeholder='Enter email address' className='mt-2'/>
            </div>

        </section>

        <section className='flex flex-col gap-10 '>
            <p className='role-section-title'>Roles(s)</p>
            <div className='role-input-section'>
                <label className='flex gap-4'>
                    <input
                    type="checkbox"
                    checked={isChecked1}
                    onChange={handleCheckboxChange1}
                    />
                    Attendant
                </label>
                {/* <br /> */}
                <label className='flex gap-4'>
                    <input
                    type="checkbox"
                    checked={isChecked2}
                    onChange={handleCheckboxChange2}
                    />
                    Manager
                </label>
                {/* <br /> */}
                <label className='flex gap-4'>
                    <input
                    type="checkbox"
                    checked={isChecked3}
                    onChange={handleCheckboxChange3}
                    />
                    Owner
                </label>
            </div>
        </section>
        {/* <div className="create-order-divider"></div> */}
        <section className='flex gap-20 mt-64'>
            <Button style={{background: 'none', color: '#434C5A', fontWeight: '400'}} onClick={OnCancel}>Cancel</Button>
            <div className='create-customer-btn'>
                <Button>Add an Employee</Button>
            </div>
            
        </section>
    </form>
  )
}

export default CreateEmployeeForm